module.exports = __webpack_public_path__ + "static/media/icon-lead-history-scheduled-event.fca991ed.svg";